global.URLBACKENDSECURITY = process.env.REACT_APP_API_SECURITY

global.URLBACKENDCATALOGO = process.env.REACT_APP_API_CATALOGO

global.URLBACKENDREQUEST = process.env.REACT_APP_API_REQUEST

global.IMG = process.env.REACT_APP_IMG
global.ROUTE_LOGIN = '*'
global.TEST_REQUEST = '/registro-local'
global.TERM_CONDITION = '/terminos-y-condiciones'
global.DIGITAL_DATA = '/uso-de-datos'
global.LOAD_LABEL_SEND = 'Enviando'
global.GLOBAL_ERROR = 'Problemas con la conexión, intente en unos minutos'
global.GLOBAL_VARIANT = 'error'
global.RESERVA_YA = '/reserva-ya'
global.EASYBUY = '/easybuy'
global.EASYBUY_TRIAL = '/registro-easybuy'

global.EASYBUY_API = process.env.REACT_APP_EASYBUY_API
global.EASYBUY_REGISTER = global.EASYBUY_API + '/platform/trial/register'

global.SEND = global.URLBACKENDREQUEST + '/sendContact'
global.PROVINCIA = global.URLBACKENDCATALOGO + '/getSelect'
global.TIPO_NEGOCIO = global.URLBACKENDCATALOGO + '/getSelectTipoNegocio'
global.TIPO_TIER = global.URLBACKENDCATALOGO + '/getSelectTier'
global.ERROR_LOG_ENDPOINT = global.URLBACKENDSECURITY + '/getLogErrorFrontMob'
global.SAVE_TEST_REQUEST = global.URLBACKENDREQUEST + '/saveTestRequest'

// contact
global.PAIS = 'Ecuador'
global.CANTON = 'Guayas'
global.CIUDAD = 'Guayaquil'

// url tuturno web
global.URLTUTURNO = 'www.google.com'
